import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    formContainer: {
        height: 'calc(100vh)',
    }
});
